'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Configuration'];
module.exports = angular.module('AVRO.Common.DirectForecasting', dependencies).factory('DirectForecastingConfigurationService', require('./services/DirectForecastingConfigurationService'));